import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Scale, X, Trash2 } from 'lucide-react';
import { compareStore, useCompareItems, COMPARE_MAX } from '../services/compareStore';
import { useT } from '../services/i18n';

// Floating bar listing the items ticked for comparison
const CompareBar = () => {
  const { t } = useT();
  const { pathname } = useLocation();
  const items = useCompareItems();
  if (!items.length || pathname === '/comparaison') return null;
  const ready = items.length >= 2;
  return (
    <div data-testid="compare-bar" className="fixed bottom-0 inset-x-0 z-40 px-3 pb-24 sm:pb-3 pointer-events-none">
      <div className="max-w-4xl mx-auto bg-[#1e3a5f] text-white rounded-xl shadow-2xl px-4 py-3 flex flex-wrap items-center gap-3 pointer-events-auto animate-in slide-in-from-bottom-4">
        <div className="flex items-center gap-2 mr-1">
          <Scale size={18} className="text-orange-400" />
          <div className="leading-tight">
            <p className="text-sm font-semibold" data-testid="compare-bar-count">{t('cmp.barTitle')} · {items.length}/{COMPARE_MAX}</p>
            <p className="text-[11px] text-blue-100">{t('cmp.barHint', { max: COMPARE_MAX })}</p>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-1 min-w-0">
          {items.map(i => (
            <div key={i.id} data-testid={`compare-bar-item-${i.id}`} className="relative bg-white rounded-lg w-12 h-12 flex items-center justify-center shrink-0" title={i.name}>
              {i.image ? <img src={i.image} alt={i.name} className="max-h-10 max-w-10 object-contain" /> : <Scale size={16} className="text-gray-400" />}
              <button type="button" onClick={() => compareStore.remove(i.id)} data-testid={`compare-bar-remove-${i.id}`} aria-label={t('cmp.remove')}
                className="absolute -top-1.5 -right-1.5 bg-red-500 hover:bg-red-600 text-white rounded-full p-0.5"><X size={10} /></button>
            </div>
          ))}
          {[...Array(COMPARE_MAX - items.length)].map((_, k) => <div key={k} className="w-12 h-12 rounded-lg border-2 border-dashed border-blue-300/50 shrink-0" />)}
        </div>
        <div className="flex items-center gap-2 ml-auto">
          <button type="button" onClick={() => compareStore.clear()} data-testid="compare-bar-clear" className="text-xs text-blue-100 hover:text-white inline-flex items-center gap-1"><Trash2 size={13} /> {t('cmp.clear')}</button>
          {ready ? (
            <Link to="/comparaison" data-testid="compare-bar-open" className="bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold px-4 py-2 rounded-md">{t('cmp.barCompare', { n: items.length })}</Link>
          ) : (
            <span data-testid="compare-bar-need-two" className="bg-white/10 text-blue-100 text-sm font-medium px-4 py-2 rounded-md cursor-not-allowed">{t('cmp.barNeedTwo')}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompareBar;
